const VUE_APP_API_MANAGE_URL = document.querySelector("body").getAttribute("api_manage_url");

export default VUE_APP_API_MANAGE_URL
